import React, { ComponentProps } from 'react';

import { BlockType } from '../../types/api/ElementType';
import { CategoriesDefaultView, CategoriesDefaultViewProps } from './views/CategoriesDefaultView';

import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { CategoriesEditView, CategoriesEditViewProps } from './views/CategoriesEditView';

type FileCategoriesBlockProps = Views<DefaultView<CategoriesDefaultViewProps> & EditView<CategoriesEditViewProps>>;

function FileCategories({ views }: FileCategoriesBlockProps) {
  const {
    editModeInfo: { active },
  } = useAppContext();

  return views.edit && active ? <CategoriesEditView {...views.edit} /> : <CategoriesDefaultView {...views.default} />;
}

export const FileCategoriesBlock = asFetchableBlock(FileCategories, BlockType.filecategories);
export type FileCategoriesBlock = ComponentProps<typeof FileCategoriesBlock>;
